// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"Footer_toolbar__2S33z","footerFlex":"Footer_footerFlex__1rSWS"};